var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParticipatoryDesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "participatory-design-a",
    x1: "0%",
    x2: "126.883%",
    y1: "36.356%",
    y2: "69.549%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2673FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#96FF51"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(9 19.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#participatory-design-a)",
    d: "M32.5756694,33.5 L30.1150395,33.5 C29.5741822,30.2753257 26.7704024,27.8181818 23.392875,27.8181818 C20.0196599,27.8181818 17.2187284,30.2690553 16.6727932,33.4876521 C12.20606,33.2480085 8.65796685,29.5502103 8.65796685,25.0237105 C8.65796685,23.6190145 9.0070667,22.2363385 9.67387854,21 L13.5825152,13.7529812 C15.3276956,10.5172353 18.7076104,8.5 22.3839817,8.5 L41.2639501,8.5 C45.0827845,8.5 48.568203,10.6749514 50.246491,14.1052351 L53.6197983,21 C55.7274757,25.3079206 53.9438262,30.5087904 49.6359056,32.6164678 C48.5076332,33.1684822 47.2737693,33.4688078 46.0196118,33.497697 C45.477806,30.2741559 42.6745572,27.8181818 39.2978339,27.8181818 C35.9203065,27.8181818 33.1165267,30.2753257 32.5756694,33.5 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 16,
    r: 4.5,
    fill: "#2673FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 34,
    r: 4.5,
    fill: "#FFBB48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 3.5,
    r: 3,
    fill: "#FF8787"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 34,
    r: 4.5,
    fill: "#2673FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 3.5,
    r: 3,
    fill: "#FFBB48"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 16,
    r: 4.5,
    fill: "#FFBB48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipatoryDesignIcon);
export default __webpack_public_path__ + "static/media/participatory-design-icon.ef9a3995943504314db59bc8e13b7139.svg";
export { ForwardRef as ReactComponent };